import { SGridProps, SCellProps } from './Grid.types';
import styled, { css } from 'styled-components';
import {
    mobileMediaQuery,
    notDesktopMediaQuery,
    onlyTabletMediaQuery
} from '../../utils/mediaQuery';

const autoRows = ({ $minRowHeight = '20px' }: SGridProps) =>
    `minmax(${$minRowHeight}, auto)`;

const frGetter = (value: string | number) =>
    typeof value === 'number' ? `repeat(${value}, 1fr)` : value;

const flow = ({ $flow: flowVal = 'row' }: SGridProps) => flowVal;

const formatAreas = (areas: string[]) =>
    areas.map((area) => `"${area}"`).join(' ');

export const Grid = styled.div<SGridProps>`
    display: grid;
    height: ${({ height = 'auto' }) => height};
    grid-auto-flow: ${flow};
    grid-auto-rows: ${autoRows};
    ${({ $rows }) =>
        $rows &&
        css`
            grid-template-rows: ${frGetter($rows)};
        `};
    grid-template-columns: ${({ $columns = 12 }) => frGetter($columns)};
    ${({ $columnGap }) =>
        $columnGap &&
        css`
            column-gap: ${$columnGap};
        `};
    row-gap: ${({ $rowGap }) => $rowGap || '16px'};
    ${({ $areas }) =>
        $areas &&
        css`
            grid-template-areas: ${formatAreas($areas)};
        `};
    ${({ $justifyContent }) =>
        $justifyContent &&
        css`
            justify-content: ${$justifyContent};
        `};
    ${({ $alignContent }) =>
        $alignContent &&
        css`
            align-content: ${$alignContent};
        `};

    grid-gap: 16px;

    ${({ $minRowHeightMobile }) =>
        $minRowHeightMobile &&
        notDesktopMediaQuery(css`
            grid-auto-rows: minmax(${$minRowHeightMobile}, auto);
        `)}

    ${onlyTabletMediaQuery(css`
        grid-template-columns: repeat(8, 1fr);
    `)}

    ${mobileMediaQuery(css`
        grid-gap: 16px 8px;
        grid-template-columns: repeat(4, 1fr);
    `)}
`;

export const Cell = styled.div<SCellProps>`
    height: 100%;
    min-width: 0;
    grid-column-end: ${({ $width = 1 }) => css`span ${$width}`};
    grid-row-end: ${({ $height = 1 }) => css`span ${$height}`};
    ${({ $left }) =>
        $left &&
        css`
            grid-column-start: ${$left};
        `};
    ${({ $top }) =>
        $top &&
        css`
            grid-row-start: ${$top};
        `};
    ${({ $center }) =>
        $center &&
        css`
            text-align: center;
        `};
    ${({ $area }) =>
        $area &&
        css`
            grid-area: ${$area};
        `};
    ${({ $middle }) =>
        $middle &&
        css`
            display: inline-flex;
            flex-flow: column wrap;
            justify-content: center;
            justify-self: stretch;
        `};

    ${({ $tabletWidth, $mobileWidth, $width = 1 }) => css`
        ${notDesktopMediaQuery(css`
            grid-column-end: span
                ${$width > 2 && $width < 4 ? 4 : $width >= 4 ? 8 : $width};
            // Не учитываем сдвиг колонок на мобильном
            grid-column-start: unset;
            ${$tabletWidth &&
            css`
                grid-column-end: span ${$tabletWidth};
            `}
        `)}

        ${mobileMediaQuery(css`
            grid-column-end: $span ${$width > 2 ? 4 : $width};
            // Не учитываем сдвиг колонок на мобильном
            grid-column-start: unset;
            ${$mobileWidth &&
            css`
                grid-column-end: span ${$mobileWidth};
            `}
        `)}
    `}
`;
